// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'
import '../static/css/element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import http from '../src/utils/http'
import utils from '../src/utils/utils'

import pageheader from '../src/components/pageheader/pageheader'
Vue.component('pageheader',pageheader)

import {message} from './utils/resetmessage'

Vue.config.productionTip = false

axios.defaults.withCredentials = false

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.http = http
Vue.prototype.utils = utils
Vue.use(ElementUI)
Vue.prototype.$message = message;

router.beforeEach((to, from, next) => {
  var user = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : '';
  if (user) {
    next()
  } else{
    if(to.path=='/' || to.path=='/deptNav/index' || to.path=='/deptNav/details'){
      next()
    }else{
      next('/')
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js